module.exports = __webpack_public_path__ + "static/media/brightspace-selector.b327d6cd.svg";